module.exports = __webpack_public_path__ + "static/media/Test19.7ed00147.bmp";